import React from 'react';

const PageNotFound = () => {
    return (
        <div>
            
            <div className="card">
                <div className="card-header">page not found </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageNotFound;
